import { Button, ButtonProps } from '@radix-ui/themes';

import styles from './ActionButton.module.css';

export const ActionButton = (props: ButtonProps) => {
    return (
        <Button
            className={styles.actionButton}
            data-radius={'full'}
            variant={'outline'}
            size='1'
            {...props}
        />
    );
};
